<template>
    <div>
        <v-row>
            <v-col cols="12" md="4">
                <v-autocomplete
                    :label="$t('item')" 
                    v-model="item_id"
                    class="me-1"
                    background-color="white" 
                    outlined 
                    :items="items"
                    item-text="display_name"
                    item-value="id"
                    dense 
                    hide-details="auto"
                >
                </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn class="primary" block @click="handleSubmit" :loading="loading">
                    <v-icon left>mdi-magnify</v-icon>
                    {{$t("search")}}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <StockOnHandItemReportData ref="StockOnHandItemReportData" :item-id="item_id" @loading="loading = $event"/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StockOnHandItemReportData from './StockOnHandItemReportData'

export default {
    components: { StockOnHandItemReportData},
    data () {
        return {
            item_id: null,
            loading: false,
        }
    },
    computed: {
        ...mapGetters({
            items:'stockJournal/item/items'
        })
    },
    methods: {
        handleSubmit() {
            this.$refs.StockOnHandItemReportData.submit();
        }
    }
}
</script>

<style>

</style>